import { render } from "./SPbarchart.vue?vue&type=template&id=44976361&scoped=true"
import script from "./SPbarchart.vue?vue&type=script&lang=js"
export * from "./SPbarchart.vue?vue&type=script&lang=js"

import "./SPbarchart.vue?vue&type=style&index=0&id=44976361&scoped=true&lang=css"

import exportComponent from "/app/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-44976361"]])

export default __exports__